import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "act-tutoring-landing" */ './ACTTutoringLandingPage'));
